<template>
    <div class="resourcesDetails" v-loading="loading">

        <div class="h100">
            <el-tabs v-model="activeTab" @tab-click="selTab()">
                <el-tab-pane :label="item.basicRename" :name="item.basicAssemblyId" v-for="(item, index) in tabList"
                             :key="index"
                             :disabled="item.fileList && item.fileList.length ? false : true"></el-tab-pane>
            </el-tabs>
            <div class="detailBox" v-loading="infoLoading">
                <div class="detailsBtnBox">
                    <div class="detailsBtn" @click="view()"><span class="el-icon-arrow-left"></span> 详细信息</div>
                    <div class="detailsBtn" @click="resourceListShow = !resourceListShow" v-if="!resourceListShow && !noDataFlag"><span
                            class="el-icon-arrow-left"></span> 资源列表
                    </div>
                </div>
                <div class="noDataBox" v-if="noDataFlag">
                    <el-image class="noData" :src="require('@/assets/img/default.png')" fit="fill"></el-image>
                    <div>暂无详情数据</div>
                </div>
                <el-row class="h100 infoBox" v-else :style="{background: previewFlag ? '#F2EEE8':'#ffffff'}">
                    <el-col :span="resourceListShow ? 20 : 24" class="h100 resourceFile">
                        <div class="noDataBox" v-if="!previewFlag">
                            <el-image class="noData" :src="require('@/assets/img/default.png')" fit="fill"></el-image>
                            <div>该文件暂不支持预览</div>
                        </div>
                        <div class="h100" v-else>
                            <iframe v-if="activeTab == '23'" id="mainIframe" ref="mainIframe" name="mainIframe"
                                    :src="threeSrc" frameborder="0" width="100%" height="100%"/>
                            <div class="audioBox flex_u_d"
                                 v-else-if="activeTab == '17' || fileInfo.fileFormat == 'mp3' || fileInfo.fileFormat == 'wav' || fileInfo.fileFormat == 'm4a'">
                                <img src="~@/assets/img/audioDefault.png" class="audioIcon">
                                <audio class="w100" controls :src="fileInfo.netUrl"></audio>
                            </div>
                            <iframe class="w100 h100" :src='onlinePreviewSrc'
                                    v-else></iframe>
                        </div>
                    </el-col>
                    <el-col :span="4" v-if="resourceListShow" class="h100">
                        <div class="resourceList">
                            <el-table
                                    :data="dataList"
                                    size="small" height="96%"
                                    class="table pointer" border @row-click="clickRow">
                                <el-table-column prop="fileName" label="资源附件表" show-overflow-tooltip>
                                    <template slot="header" slot-scope="scope">
                                        <div class="flex_b_c">
                                            <div>资源附件表</div>
                                            <div class="el-icon-close"
                                                 @click="resourceListShow = !resourceListShow"></div>
                                        </div>
                                    </template>
                                    <template slot-scope="{row}">
                                        {{row.fileName || row.compressName}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="flex_b_t m_t1">
                <div class="flex_1 m_r1">
                    <div :class="labelUnfold ? 'unfoldBox':'unfoldBox2'">
                        <div ref="labelUnfoldBox">
                            <el-select class="m_r1" size="mini"
                                       v-model.trim="inputValue" v-if="inputVisible"
                                       filterable
                                       allow-create
                                       default-first-option placeholder="选择或输入标签" @change="changeIpt">
                                <el-option
                                        v-for="item in labelOpt"
                                        :key="item.id"
                                        :label="item.labelName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <el-button type="primary" class="button-new-tag" size="mini"
                                       @click="showInput">
                                +添加标签
                            </el-button>
                            <el-tag class="m_l1" size="medium" v-for="(item, index) in labelList" :key="index" closable
                                    @close="delLabel(item)">
                                {{ item.labelName }}
                            </el-tag>
                        </div>
                    </div>
                    <div class="moreBox" v-show="labelUnfoldBoxH > 33">
                        <div class="moreBtn" @click="labelUnfold = !labelUnfold">
                            <span class="more">更多</span>
                            <span :class="labelUnfold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></span>
                        </div>
                    </div>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-star-off" v-if="isCollect == '1'" @click="collect()"
                               v-noMoreClick size="mini">收藏
                    </el-button>
                    <el-button type="primary" icon="el-icon-star-on" v-else @click="cancelCollect()" v-noMoreClick
                               size="mini">取消收藏
                    </el-button>
                    <el-button type="primary" icon="el-icon-download" v-if="!noDataFlag" @click="downloadFile()" v-noMoreClick size="mini">
                        下载
                    </el-button>
                    <el-button v-if="activeTab == '23' && fileInfo.fileFormat == 'zip'" :type="threeIframeType ? '' : 'primary'" icon="el-icon-thumb" @click="rangingThree()" v-noMoreClick size="mini">
                        测量
                    </el-button>
                </div>
            </div>
        </div>
        <ResourceAddEditForm ref="resourceAddEditForm"></ResourceAddEditForm>
    </div>
</template>

<script>
    import ResourceAddEditForm from '@/views/modules/dyygCollect/library/resourceAddEditForm'

    export default {
        components: {ResourceAddEditForm},
        data() {
            return {
                id: this.$route.query.id,
                basicDataId: this.$route.query.basicDataId,
                activeTab: '23',
                resourceListShow: false,
                previewFlag: true,  // 是否支持预览
                noDataFlag: false,  // 是否有文件数据
                threeIframeType: true, // 三维是否支持测量
                tabList: [
                    {
                        basicAssemblyId: '23',
                        basicRename: '三维',
                    },
                    {
                        basicAssemblyId: '14',
                        basicRename: '图片',
                    },
                    {
                        basicAssemblyId: '17',
                        basicRename: '音频',
                    },
                    {
                        basicAssemblyId: '15',
                        basicRename: '视频',
                    },
                    {
                        basicAssemblyId: '13',
                        basicRename: '文件',
                    },
                    {
                        basicAssemblyId: '25',
                        basicRename: '附件',
                    },
                ],
                threeSrc: '/static/threeJs/examples/basics_obj.html',
                dataList: [],
                fileInfo: {},
                loading: false,
                infoLoading: false,
                onlinePreviewSrc: '',
                // 标签
                labelList: [],
                labelOpt: [],
                inputVisible: false,
                inputValue: '',
                labelUnfoldBoxH: 0,
                labelUnfold: false,
                isCollect: '1',
            }
        },
        computed: {
            // 页签数据
            resourcesDetailsGuide: {
                get() {
                    return this.$store.state.common.resourcesDetailsGuide
                },
                set(val) {
                    this.$store.commit('common/updateResourcesDetailsGuide', val)
                }
            },
        },
        created() {
            this.getGuide()
        },
        mounted() {
            this.threeIframeType = true
            this.$axios(this.api.metadata.metadataDataPageView, {metadataId: this.id}).then()
            this.getInfo()
        },
        methods: {
            getInfo() {
                this.loading = true
                this.$axios(this.api.metadata.metadatadataGetById + '/' + this.id).then(data => {
                    if (data.status && data.data) {
                        this.isCollect = data.data.isCollect || '1'
                        this.tabList.map(item => {
                            switch (item.basicAssemblyId) {
                                case "23":
                                    this.$set(item, 'fileList', data.data.threeAttachments || [])
                                    break
                                case "14":
                                    this.$set(item, 'fileList', data.data.imageAttachments || [])
                                    break
                                case "17":
                                    this.$set(item, 'fileList', data.data.audioAttachments || [])
                                    break
                                case "15":
                                    this.$set(item, 'fileList', data.data.videoAttachments || [])
                                    break
                                case "13":
                                    this.$set(item, 'fileList', data.data.fileAttachments || [])
                                    break
                                case "25":
                                    this.$set(item, 'fileList', data.data.metadataAttachments || [])
                                    break
                            }
                        })
                        this.$nextTick(() => {
                            let list = this.tabList.filter(v => v.fileList && v.fileList.length)
                            if (list.length) {
                                this.getPassLabelList()
                                this.getLabelList()
                                this.activeTab = list[0].basicAssemblyId
                                this.$nextTick(() => {
                                    this.selTab()
                                })
                            } else {
                                this.noDataFlag = true
                            }
                        })
                    } else {
                        this.noDataFlag = true
                    }
                    this.loading = false
                })
            },
            // 选择tab
            selTab() {
                this.previewFlag = true
                this.dataList = this.tabList.filter(v => v.basicAssemblyId == this.activeTab)[0].fileList
                this.$nextTick(() => {
                    this.clickRow(this.dataList[0])
                })
            },
            // 点击列表行
            clickRow(val) {
                this.fileInfo = val
                this.onlinePreview(this.fileInfo.netUrl, this.fileInfo.fileName).then(result => {
                    this.onlinePreviewSrc = result
                })
                this.previewFlag = true
                let type = this.activeTab
                if (this.activeTab == '25') {
                    type = '13'
                }
                let format = this.getSupportPreviewFileFormat(type)
                if (format && format.indexOf(val.fileFormat) == -1) {
                    this.previewFlag = false
                    this.$message.error('暂不支持预览' + val.fileFormat + '格式')
                    return
                }
                this.infoLoading = true
                if (val.threeList) {
                    this.showThree(val.threeList)
                } else {
                    this.infoLoading = false
                }
            },
            // 展示三维
            showThree(data, iframeSrc) {
                if(!iframeSrc) {
                    this.threeIframeType = true
                } else {
                    this.threeIframeType = false
                }
                this.infoLoading = false
                let iframeData
                if (data.obj && data.mtl && data.img) {
                    this.threeSrc = iframeSrc ? iframeSrc : '/static/threeJs/examples/basics_obj.html'
                    iframeData = {
                        mtlUrl: data.mtl.netUrl,
                        objUrl: data.obj.netUrl,
                        imgUrl: data.img,
                    }
                } else if (data.stl) {
                    this.threeSrc = '/static/threeJs/examples/basics_stl.html'
                    iframeData = {
                        stlUrl: data.stl.netUrl,
                    }
                } else if (data.glb) {
                    this.threeSrc = '/static/threeJs/examples/basics_glb.html'
                    iframeData = {
                        stlUrl: data.glb.netUrl,
                    }
                } else {
                    this.$message('缺失文件')
                    this.previewFlag = false;
                    return
                }
                const mapFrame = this.$refs['mainIframe']
                mapFrame.contentWindow.location.reload()
                if (mapFrame.attachEvent) {
                    mapFrame.attachEvent('onload', function () {
                        const iframeWin = mapFrame.contentWindow
                        iframeWin.postMessage(iframeData, '*')
                    })
                } else {
                    mapFrame.onload = function () {
                        const iframeWin = mapFrame.contentWindow
                        iframeWin.postMessage(iframeData, '*')
                    }
                }
            },
            // 测距
            rangingThree() {
                this.threeIframeType = !this.threeIframeType
                if (!this.threeIframeType) {
                    this.showThree(this.fileInfo.threeList, '/static/threeJs/examples/test_obj.html')
                } else {
                    this.showThree(this.fileInfo.threeList)
                }
            },
            // 详细信息
            view() {
                this.$refs.resourceAddEditForm.init('view', this.id, '', this.basicDataId)
            },
            // 收藏
            collect() {
                this.$axios(this.api.metadata.academicMyCollectionSave, [{
                    basicDataId: this.basicDataId,
                    metadataId: this.id,
                }], 'post').then(data => {
                    if (data.status) {
                        this.$message.success('收藏成功')
                        this.isCollect = '0'
                    } else {
                        this.$message.error('收藏失败')
                    }
                })
            },
            // 取消收藏
            cancelCollect() {
                this.$axios(this.api.metadata.academicMyCollectionUpdateByIds, [this.id], 'post').then(data => {
                    if (data.status) {
                        this.$message.success('取消收藏成功')
                        this.isCollect = '1'
                    } else {
                        this.$message.error('取消收藏失败')
                    }
                })
            },
            // 下载
            downloadFile() {
                this.$confirm(`确认下载所选资源?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let resourceName = this.fileInfo.fileName || this.fileInfo.compressName || ''
                    this.fileBlobDownload(this.api.allCommon.fileDownload, {
                        resourceName,
                        source:  this.fileInfo.netUrl || this.fileInfo.compressUrl || '',
                    }, resourceName, '', 'get')
                })
            },
            // 获取审核通过的所有标签
            getPassLabelList() {
                this.$axios(this.api.academic.queryLabelLis, {resourcesId: this.id}).then(res => {
                    if (res.status) {
                        this.labelOpt = res.data
                    }
                })
            },
            // 获取当前资源标签
            getLabelList() {
                this.$axios(this.api.academic.getByResourcesId + '/' + this.id).then(res => {
                    if (res.status) {
                        this.labelList = res.data
                        setTimeout(() => {
                            this.labelUnfoldBoxH = this.$refs.labelUnfoldBox.offsetHeight
                        }, 500)
                    }
                })
            },
            // 删除标签
            delLabel(item) {
                this.$confirm(`确定删除标签吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.academic.resourceslabelRemoveById, {ids: [item.id]}, 'delete').then(res => {
                        if (res.status) {
                            this.$message.success("操作成功")
                            this.getLabelList()
                            this.getPassLabelList()
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                })
            },
            // 显示添加标签输入框
            showInput() {
                this.inputVisible = true;
            },
            // 新增标签
            changeIpt(val) {
                if (!val.trim()) {
                    this.$message('请输入标签内容')
                    return
                }
                let api = this.api.academic.resourceslabelSave
                let item = this.labelOpt.filter(v => v.id == val)
                if(!item.length && val.length > 20) {
                    this.$message('标签内容不能超过20个字')
                    this.inputValue = ''
                    return
                }
                let obj = {
                    resourcesId: this.id,
                    basicDataId: this.basicDataId,
                    labelName: val
                }
                if (item.length) {
                    obj = {
                        resourcesId: this.id,
                        basicDataId: this.basicDataId,
                        labelId: val
                    }
                    api = this.api.academic.resourceslabelPassSave
                }
                this.$axios(api, obj, 'post').then(res => {
                    if (res.status) {
                        this.$message.success('新增成功')
                        this.getLabelList();
                        this.getPassLabelList()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
                this.inputValue = '';
                this.inputVisible = false;
            },
            // 获取引导
            getGuide() {
                this.$axios(this.api.user.getByType, {type: '0'}).then(data => {
                    if (data.status && data.data) {
                        this.resourcesDetailsGuide = true
                    }
                })
            },
        },
        //离开此页面
        beforeRouteLeave(to, from, next) {
            if(to.path != '/academic/resourceList/resourceList') {
                sessionStorage.removeItem('resourceData')
            }
            next();
        },
    }
</script>

<style scoped>

</style>
